"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpDefinitionCopy = void 0;
const OpDefinitionModel_1 = __importDefault(require("@opsbase/lib-data-model/models/OpDefinitionModel"));
const GQLMutationHook_1 = __importDefault(require("@opsbase/react-gql/GQLMutationHook"));
const GQLResponseType_1 = __importDefault(require("@opsbase/react-gql/GQLResponseType"));
const GQLType_1 = __importDefault(require("@opsbase/react-gql/GQLType"));
const OpDefinitionCopyConfig = {
    type: GQLType_1.default.MUTATION,
    model: OpDefinitionModel_1.default,
    name: 'copyOpDefinitions',
    response: GQLResponseType_1.default.ARRAY,
    params: {
        organisationId: 'String',
        ids: '[String]',
        patches: '[OpDefinitionPatch]',
        shouldCopyBusinessRules: 'Boolean',
    },
    refetchQueries: ['opdefinitions', 'OPDEFINITIONS'],
};
exports.useOpDefinitionCopy = (0, GQLMutationHook_1.default)(OpDefinitionCopyConfig);
exports.default = exports.useOpDefinitionCopy;
